import { CargaOportunidad } from "../../components";

const CargarOportunidad = () => (
  <div>
    <CargaOportunidad />
  </div>
);

export default CargarOportunidad;
